import React, { Fragment } from "react";
import { Box } from "@material-ui/core";

const Spacer = ({ x = 20, y = 0, children = <div /> }) => <Box style={{ margin: `${x}px ${y}px` }}>{children}</Box>;

export default Spacer;
